export const PROTOTYPE_KIND_LABEL = { design: "Prototype" };
export const PROTOTYPE_VIEW_MESSAGE = "yagni:prototype:view";
export const PLAN_ARTIFACT_KINDS = ["design"];
//# sourceMappingURL=prototypeWorkflow.js.map